import { isIframe } from '.';

interface Message<T> {
    type: T;
    payload?: object;
}

type TycoonMessageType = 'chat_created' | 'chat_deleted' | 'chat_not-found' | 'iframe-inited';
type QuasarMessageType = 'quasar_account-linking_result' | 'quasar_to-device-list';

const sendMessageToParent = <T>(message: string | Message<T>, origin: string) => {
    if (!isIframe()) {
        return;
    }

    const finalMessage = typeof message === 'string' ? message : JSON.stringify(message);

    window.parent.postMessage(finalMessage, origin);
};

const postTycoonMessage = (message: string | Message<TycoonMessageType>) => {
    sendMessageToParent(message, '*');
};

export const tycoon = {
    sendChatCreation: (skillId: string) => {
        postTycoonMessage({
            type: 'chat_created',
            payload: { chatId: skillId },
        });
    },

    sendChatDeletion: (skillId: string) => {
        postTycoonMessage({
            type: 'chat_deleted',
            payload: { chatId: skillId },
        });
    },

    sendChatNotFound: (skillId: string) => {
        postTycoonMessage({
            type: 'chat_not-found',
            payload: { chatId: skillId },
        });
    },

    sendIframeInited: () => {
        postTycoonMessage({
            type: 'iframe-inited',
        });
    },
};

const sendMessageToChild = <T>(message: string | Message<T>, origin: string) => {
    if (!window.frames[0]) {
        return;
    }

    const frame = window.frames[0];

    const finalMessage = typeof message === 'string' ? message : JSON.stringify(message);

    frame.postMessage(finalMessage, origin);
};

const postQuasarUiMessage = (message: string | Message<QuasarMessageType>) => {
    sendMessageToChild(message, '*');
};

export const quasar = {
    sendAccountLinkingResult: (status: 'ok' | 'error') => {
        postQuasarUiMessage({
            type: 'quasar_account-linking_result',
            payload: { status },
        });
    },
    moveToDeviceList: () => {
        postQuasarUiMessage({
            type: 'quasar_to-device-list',
        });
    },
};
